export const BANNERS_BY_INDEXES_MOBILE = {
    3: '300x250_2',
    7: '300x250_3',
    11: '300x250_4',
    15: '300x250_5',
    19: '300x250_6',
};
